import { defineBlock } from "eddev/blocks"
import { LatestNewsPanel } from "@components/molecules/LatestNewsPanel"
import { LatestNewsSlider } from "@components/molecules/LatestNewsSlider"
import { useLatestNews } from "@hooks/queries"
import { ArticleCardFragment } from "../../types.graphql"
import { useEffect, useMemo, useState } from "react"

export const meta: BlockMeta = {
  title: "Curated News",
  category: "common",
  icon: "slides",
  keywords: ["news"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("news/curated-news", (props) => {
  const [link, setLink] = useState<string>("/newsroom/news-archive")
  const [categories, setCategories] = useState<string>("")
  const [tags, setTags] = useState<string>("")
  const selection = useLatestNews({ count: 12, category: categories, tag: tags })

  const getLink = () => {
    const catLink = categories.length > 0 ? `categories=${categories}` : ``
    const tagLink = tags.length > 0 ? `tags=${tags}` : ``

    setLink(`/newsroom/news-archive?${catLink}${catLink.length > 0 ? `&` : ``}${tagLink}`)
  }

  const articles = useMemo(() => {
    if (props.selectionType === "curated") {
      if (props.byPosts) {
        return props.byPosts.map((article) => article) as ArticleCardFragment[]
      } else {
        return []
      }
    } else {
      // Taxonomy
      if (selection.data?.posts?.nodes) {
        return selection.data.posts.nodes
      } else {
        return []
      }
    }
  }, [props.selectionType, categories, tags, selection])

  useEffect(() => {
    if (props.byCategory) {
      setCategories(props.byCategory.map((cat) => cat?.name).join())
    } else {
      setCategories("")
    }

    if (props.byTag) {
      setTags(props.byTag.map((tag) => tag?.slug).join())
    } else {
      setTags("")
    }
  }, [props])

  useEffect(() => {
    getLink()
  }, [categories, tags])

  return (
    <>
      {articles && (
        <>
          {props.displayType === "grid" ? (
            <LatestNewsPanel
              articles={articles}
              link={link}
              headerStyle={props?.headerStyle as "subtitle" | "regular" | "hide"}
              viewAllStyle={props.viewAllStyle as "none" | "light" | "dark"}
            />
          ) : (
            <LatestNewsSlider articles={articles} />
          )}
        </>
      )}
    </>
  )
})
